export function menuComponent (name) {
  return () => import(`@/view/${name}.vue`)
}
export function menuProps (props) {
  return (route) => {
    let obj = {}
    props.map((item, index) => {
      obj[item] = route.query[item]
    })
    return obj
  }
}



// WEBPACK FOOTER //
// ./src/utils/menuModule.js